const quickAddBrandIds: Array<string> = [
  'aldi',
  'amazon',
  'bq',
  'boots',
  'disney',
  'halfords',
  'ikea',
  'lidl',
  'netflix',
  'primark',
  'sainsburys',
  'spotify',
  'tesco',
];

export { quickAddBrandIds };
